import React from "react";
import { connect } from "react-redux";
import * as storeService from "../addRuleStoreService";

function DetailsField({ rule, disabled }) {

    const onChange = (value) => {
        storeService.changeRule({ ...rule, details: value })
    }

    return (
        <div className="addrules-form-group-v2">
            <label className="addrules-form-label-v2">Description</label>
            <textarea
                className="addrules-form-textarea-v2"
                value={rule.details || ''}
                disabled={disabled}
                onChange={disabled ? null : event => onChange(event.target.value)}
                rows="5"
            />
        </div>
    )

}

function mapStateToProps(state) {
    return {
        rule: state.addRulesPage.rule || {}
    }
}

export default connect(mapStateToProps)(DetailsField);
